import { render } from "./doorTitle.vue?vue&type=template&id=db9faaec&scoped=true"
import script from "./doorTitle.vue?vue&type=script&lang=js"
export * from "./doorTitle.vue?vue&type=script&lang=js"

import "./doorTitle.vue?vue&type=style&index=0&id=db9faaec&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db9faaec"]])

export default __exports__